export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Demande de support technique"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["de"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter un message"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fichiers"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vous pouvez télécharger un ou plusieurs fichiers. Taille maximale du fichier - 10 Mo."])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Texte du message"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer"])}
}